const STALE_UPLOAD_TIMEOUT_MS = 1_800_000;

export { STALE_UPLOAD_TIMEOUT_MS };
